import {useSignal, useSignals} from '@preact/signals-react/runtime'
import {useQueryClient} from '@tanstack/react-query'
import {Dialog} from 'primereact/dialog'
import {forwardRef, useImperativeHandle, useMemo} from 'react'
import {
    QueryCRUDTypes,
    QueryKeyManager,
} from '../../../query-manager/QueryKeysManager'
import {QueryKeyTypes} from '../../../query-manager/QueryKeyTypes'
import {
    blockOverflownScroll,
    unblockOverflownScroll,
} from '../../../utils/BlockScrollsUtils'
import {useAuth} from '../../authentication/AuthProvider'
import {updateImgList} from '../../detail/DetailConstant'
import CustomForm from '../../form-utils/CustomForm'
import {formLayout} from '../../form/Constant'
import {usePatientBasicCRUD} from '../../patient/query-keys/PatientKeysManager'
import {usePatientContext} from './StyleDetailInformationWrapper'

const StyledChangeAvatarForm = forwardRef((props, ref) => {
    useSignals()

    useImperativeHandle(ref, () => ({
        showForm: handleShowForm,
        hideForm: handleHideForm,
    }))

    const {user} = useAuth()
    const {currentViewedUser} = usePatientContext()

    const visible = useSignal(false)

    const handleShowForm = () => {
        blockOverflownScroll()
        visible.value = true
    }

    const handleHideForm = () => {
        unblockOverflownScroll()
        visible.value = false
    }

    const queryClient = useQueryClient()
    const {patientKeys} = QueryKeyManager(QueryKeyTypes.patient, user?.id)

    const patientQueryKeys = useMemo(() => {
        return patientKeys.detail({id: currentViewedUser?.id})
    }, [currentViewedUser?.id, patientKeys])

    const {mutateAsync: createOrUpdatePatient} = usePatientBasicCRUD(
        QueryCRUDTypes.update,
        user?.id,
    )

    const handleUpdateImg = async value => {
        let toPostData = {
            ...currentViewedUser,
            ...value,
            byPassPathway: true,
            byPassAdditionalInfo: true,
            byPassAddress: true,
            byPassNOK: true,
            byPassHospital: true,
            byPassHCP: true,
            byPassRole: true,
            byPassSupportTeam: true,
        }

        const patientData = await createOrUpdatePatient(toPostData)
        if (patientData?.id) {
            queryClient.invalidateQueries(patientQueryKeys)

            handleHideForm()
        }
    }

    return (
        <Dialog
            header={
                <h5 className="mb-0 font-bold">
                    <strong>{'Change Avatar'}</strong>
                </h5>
            }
            style={{width: '40vw'}}
            breakpoints={{'960px': '75vw', '641px': '100vw'}}
            visible={visible.value}
            onHide={handleHideForm}>
            <CustomForm
                onSubmit={handleUpdateImg}
                layout={formLayout.inline}
                dataList={updateImgList}
            />
        </Dialog>
    )
})

export default StyledChangeAvatarForm
